import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LoadingState, StateMessage } from '@/components/StateMessage/StateMessage';
import { useFeatureFlags } from '@/features/platform/useFeatureFlags';
import styles from '@/features/projects/ProjectGate.module.css';

export function AutomationsFlagGate({ children }: { children: ReactNode }) {
  const { isEnabled, isLoading } = useFeatureFlags();

  if (isLoading) return <LoadingState />;
  if (!isEnabled('automations_v1')) {
    return (
      <StateMessage title="Automations (v1) staat uit">
        Schakel de feature flag in via Instellingen → Platform (org owner).
        <div className={styles.actions}>
          <Link to="/app/instellingen/platform" className={styles.link}>
            Naar platforminstellingen
          </Link>
        </div>
      </StateMessage>
    );
  }
  return <>{children}</>;
}
